import { DOMParser } from "prosemirror-model";
import { MarkdownParser } from "prosemirror-markdown";
import MarkdownIt from "markdown-it";
import { EditorState } from "prosemirror-state";
import { markdownItTable } from "markdown-it-table";
import { markdownTokens } from "./md-schema";
import { createFullPresetExtensions } from "../presets/full-preset";
import { generateSchema } from "../core/extension";
export function htmlToNodes(html, schema) {
    const dom = document.createElement("div");
    dom.innerHTML = html;
    const parser = DOMParser.fromSchema(schema);
    const doc = parser.parse(dom);
    return doc.content;
}
export function markdownToNodes(markdown, schema) {
    const markdownIt = MarkdownIt("commonmark", {
        html: false,
    });
    markdownIt.use(markdownItTable, {});
    // return markdownIt.parse(markdown) as unknown as Fragment
    const mdParser = new MarkdownParser(schema, markdownIt, markdownTokens);
    const doc = mdParser.parse(markdown, {
        tightLists: true,
    });
    return doc.content;
}
export const parseJSONToFieldValue = (text) => {
    try {
        return JSON.parse(text);
    }
    catch (error) {
        return null;
    }
};
export const parseHTMLToDoc = (html) => {
    const schema = generateSchema(createFullPresetExtensions());
    const editor = document.createElement("div");
    let innerHtml = html.replace(/(^"|"$)/g, "");
    innerHtml = removeImageFromHTML(innerHtml);
    innerHtml = removeAttachmentFromHTML(innerHtml);
    editor.innerHTML = innerHtml;
    const domParser = DOMParser.fromSchema(schema);
    const state = EditorState.create({
        schema,
        doc: domParser.parse(editor),
    });
    return state.doc.toJSON();
};
const removeImageFromHTML = (html) => html.replace(/<figure[\s\S]*<\/figure>/g, "");
export const removeAttachmentFromHTML = (html) => html.replace(/<a class="attachment[\s\S]*<\/a>/g, "");
